import { playerTypeEnum } from 'common/commonEnum';
import { TimeFrameValue } from '../common/types';
import { TimeFrameValueEnum } from 'common/common';

export interface Timeframe {
  id: number;
  value: TimeFrameValue;
  label: string;
  label2: string;
  description: string;
  timeframeHours?: null | number;
  timeframeWeeks?: null | number;
  timeframeMonths?: null | number;
  timeName?: string;
  timeBucket?: string;
  display_order: number;
  playerTypeAccess: playerTypeEnum[];
}

export enum TimeframeSections {
  Home = 'hottestSlots',
  Details = 'details',
  Recent = 'myplay',
  Leaderboard = 'leaderboard',
  Jackpots = 'jackpot',
  Favorites = 'favorites',
}

export interface ITimeframeAccess {
  value: TimeFrameValue;
  playerTypeAccess: playerTypeEnum[];
}

export interface TimeRangeOption {
  label: string;
  value: TimeFrameValue;
  playerTypeAccess?: playerTypeEnum[];
  display_order: number;
}

export const AllTimeFrames: any[] = [
  {
    id: 1,
    value: TimeFrameValueEnum.hours1,
    label: '1 hr',
    label2: '1 hr',
    description: '1 hr',
    timeframeHours: 1,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: '1H',
    timeBucket: '5 m',
    graphtimeBucket: '1 H',
    display_order: 1,
    sections: [
      TimeframeSections.Home,
      TimeframeSections.Details,
      TimeframeSections.Leaderboard,
      TimeframeSections.Jackpots,
      TimeframeSections.Favorites,
    ],
  },
  {
    id: 2,
    value: TimeFrameValueEnum.hours4,
    label: '4 hrs',
    label2: '4 hrs',
    description: '4 hrs',
    timeframeHours: 4,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: '4H',
    timeBucket: '5 m',
    graphtimeBucket: '4 H',
    display_order: 2,
    sections: [
      TimeframeSections.Home,
      TimeframeSections.Details,
      TimeframeSections.Leaderboard,
      TimeframeSections.Jackpots,
      TimeframeSections.Favorites,
    ],
  },
  {
    id: 3,
    value: TimeFrameValueEnum.hours8,
    label: '8 hrs',
    label2: '8 hrs',
    description: '8 hrs',
    timeframeHours: 8,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: '8H',
    timeBucket: '5 m',
    graphtimeBucket: '8 H',
    display_order: 3,
    sections: [
      TimeframeSections.Home,
      TimeframeSections.Details,
      TimeframeSections.Leaderboard,
      TimeframeSections.Jackpots,
      TimeframeSections.Favorites,
    ],
  },
  {
    id: 4,
    value: TimeFrameValueEnum.hours24,
    label: '24 hrs',
    label2: '24 hrs',
    description: '24 hrs',
    timeframeHours: 24,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: 'DAY',
    timeBucket: '5 m',
    graphtimeBucket: '1 d',
    display_order: 4,
    sections: [
      TimeframeSections.Home,
      TimeframeSections.Details,
      TimeframeSections.Recent,
      TimeframeSections.Leaderboard,
      TimeframeSections.Jackpots,
      TimeframeSections.Favorites,
    ],
  },
  {
    id: 5,
    value: TimeFrameValueEnum.weeks1,
    label: '7 days',
    label2: '7 days',
    description: '7 days',
    timeframeHours: null,
    timeframeWeeks: 1,
    timeframeMonths: null,
    timeName: 'WEEK',
    timeBucket: '1 d',
    graphtimeBucket: '7 d',
    display_order: 5,
    sections: [
      TimeframeSections.Home,
      TimeframeSections.Details,
      TimeframeSections.Recent,
      TimeframeSections.Leaderboard,
      TimeframeSections.Jackpots,
      TimeframeSections.Favorites,
    ],
  },
  {
    id: 6,
    value: TimeFrameValueEnum.months1,
    label: '30 days',
    label2: '30 days',
    description: '30 days',
    timeframeHours: null,
    timeframeWeeks: null,
    timeframeMonths: 1,
    timeName: 'MONTH',
    timeBucket: '1 d',
    graphtimeBucket: '30 d',
    display_order: 6,
    sections: [
      TimeframeSections.Home,
      TimeframeSections.Details,
      TimeframeSections.Recent,
      TimeframeSections.Leaderboard,
      TimeframeSections.Jackpots,
      TimeframeSections.Favorites,
    ],
  },
  {
    id: 7,
    value: TimeFrameValueEnum.sinceLastJackpot,
    label: 'Since Last Jackpot (SLJ)',
    label2: 'Since Last Jackpot (SLJ)',
    description: 'Since Last Jackpot',
    timeName: 'SLJ',
    timeBucket: '1 d',
    graphtimeBucket: '30 d',
    display_order: 7,
    sections: [
      TimeframeSections.Home,
      TimeframeSections.Details,
      TimeframeSections.Jackpots,
      TimeframeSections.Favorites,
    ],
  },
  {
    id: 8,
    value: TimeFrameValueEnum.sinceLastVisit,
    label: 'Since Last Visit (SLV)',
    label2: 'Since Last Visit (SLV)',
    description: 'Since Last Visit',
    display_order: 8,
    sections: [TimeframeSections.Jackpots, TimeframeSections.Favorites],
  },
  {
    id: 9,
    value: TimeFrameValueEnum.all,
    label: '1 Year',
    label2: '1 Year',
    description: '1 Year',
    display_order: 9,
    sections: [TimeframeSections.Jackpots],
  },
  {
    id: 10,
    value: TimeFrameValueEnum.lastThreeYears,
    label: 'Last 3 Years',
    label2: 'Last 3 Years',
    description: 'Last 3 Years',
    display_order: 10,
    sections: [],
  },
  {
    id: 11,
    value: TimeFrameValueEnum.allJackpots,
    label: 'All Jackpots',
    label2: 'All Jackpots',
    description: 'All Jackpots',
    display_order: 11,
    sections: [TimeframeSections.Jackpots, TimeframeSections.Favorites],
  },
];

export const timeFrameAccessList: ITimeframeAccess[] = [
  {
    value: TimeFrameValueEnum.hours1,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
  {
    value: TimeFrameValueEnum.hours4,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
  {
    value: TimeFrameValueEnum.hours8,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
  {
    value: TimeFrameValueEnum.hours24,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
  {
    value: TimeFrameValueEnum.weeks1,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
  {
    value: TimeFrameValueEnum.months1,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
  { value: TimeFrameValueEnum.sinceLastJackpot, playerTypeAccess: [playerTypeEnum.slotCheckPro] },
];

export const TimeFramesItems: Omit<Timeframe, 'playerTypeAccess'>[] = [
  {
    id: 1,
    value: TimeFrameValueEnum.hours1,
    label: '1 hr',
    label2: '1 hr',
    description: '1 hr',
    timeframeHours: 1,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: '1h',
    timeBucket: '5 m',
    display_order: 1,
  },
  {
    id: 2,
    value: TimeFrameValueEnum.hours4,
    label: '4 hrs',
    label2: '4 hrs',
    description: '4 hrs',
    timeframeHours: 4,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: '4h',
    timeBucket: '5 m',
    display_order: 2,
  },
  {
    id: 3,
    value: TimeFrameValueEnum.hours8,
    label: '8 hrs',
    label2: '8 hrs',
    description: '8 hrs',
    timeframeHours: 8,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: '8h',
    timeBucket: '5 m',
    display_order: 3,
  },
  {
    id: 4,
    value: TimeFrameValueEnum.hours24,
    label: '24 hrs',
    label2: '24 hrs',
    description: '24 hrs',
    timeframeHours: 24,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: 'DAY',
    timeBucket: '5 m',
    display_order: 4,
  },
  {
    id: 5,
    value: TimeFrameValueEnum.weeks1,
    label: '7 days',
    label2: '7 days',
    description: '7 days',
    timeframeHours: null,
    timeframeWeeks: 1,
    timeframeMonths: null,
    timeName: 'WEEK',
    timeBucket: '8 h',
    display_order: 5,
  },
  {
    id: 6,
    value: TimeFrameValueEnum.months1,
    label: '30 days',
    label2: '30 days',
    description: '30 days',
    timeframeHours: null,
    timeframeWeeks: null,
    timeframeMonths: 1,
    timeName: 'MONTH',
    timeBucket: '1 d',
    display_order: 6,
  },
  {
    id: 7,
    value: TimeFrameValueEnum.sinceLastJackpot,
    label: 'Since Last Jackpot (SLJ)',
    label2: 'SLJ',
    description: 'Since Last Jackpot',
    timeframeHours: null,
    timeframeWeeks: null,
    timeframeMonths: null,
    timeName: 'SLJ',
    timeBucket: '1 d',
    display_order: 7,
  },
];

export const TimeFrames: Timeframe[] = TimeFramesItems.map((item) => {
  const access = timeFrameAccessList.find((a) => a.value === item.value);
  if (!access) {
    throw new Error(`Missing playerTypeAccess for timeframe: ${item.value}`);
  }

  return {
    ...item,
    playerTypeAccess: access.playerTypeAccess,
  };
});

export const defaultTimeRangesList: TimeRangeOption[] = [
  {
    label: '4h',
    value: TimeFrameValueEnum.hours4,
    display_order: 5,
  },
  {
    label: '8h',
    value: TimeFrameValueEnum.hours8,
    display_order: 4,
  },
  {
    label: '24h',
    value: TimeFrameValueEnum.hours24,
    display_order: 3,
  },
  {
    label: '7d',
    value: TimeFrameValueEnum.weeks1,
    display_order: 2,
  },
  {
    label: '30d',
    value: TimeFrameValueEnum.months1,
    display_order: 1,
  },
];

export const defaultTimeRanges = defaultTimeRangesList
  .map((tf) => {
    const matchingAccess = timeFrameAccessList.find((fa) => fa.value === tf.value);
    return {
      ...tf,
      ...(matchingAccess ? { playerTypeAccess: matchingAccess.playerTypeAccess } : {}),
    };
  })
  .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

export const spinsTimeFramesItem = TimeFrames.map((tf) =>
  tf.value === TimeFrameValueEnum.weeks1
    ? { ...tf, playerTypeAccess: [playerTypeEnum.slotCheckPro] }
    : tf.value === TimeFrameValueEnum.months1
    ? { ...tf, playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro] }
    : tf
);

export const spinsTimeFrames = spinsTimeFramesItem.map((tf) => {
  const matchingAccess = timeFrameAccessList.find((fa) => fa.value === tf.value);
  return {
    ...tf,
    ...(matchingAccess ? { playerTypeAccess: matchingAccess.playerTypeAccess } : {}),
  };
});

export const myJackpotTimeFrames: Timeframe[] = [
  {
    id: 9,
    value: 'all',
    label: '1 Year',
    label2: '1 Year',
    description: '1 Year',
    display_order: 9,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
  // {
  //   id: 10,
  //   value: "lastThreeYears",
  //   label: "Last 3 Years",
  //   label2: "Last 3 Years",
  //   description: "Last 3 Years",
  //   display_order: 10,
  //   playerTypeAccess: [playerTypeEnum.slotCheckPro]
  // },
  {
    id: 11,
    value: 'allJackpots',
    label: 'All Jackpots',
    label2: 'All Jackpots',
    description: 'All Jackpots',
    display_order: 11,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
];

export const myPlayTimeFrames: Timeframe[] = [
  {
    id: 8,
    value: 'sinceLastVisit',
    label: 'Since Last Visit (SLV)',
    label2: 'Since Last Visit (SLV)',
    description: 'Since Last Visit',
    display_order: 8,
    playerTypeAccess: [playerTypeEnum.slotCheck, playerTypeEnum.slotCheckPro],
  },
];
